import React from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const GRNMenu_report = () => {
   useAuthRedirect();
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Good Receipt Note - Report
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Report</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/grnViewReport">GRN - Report</Link></td>
          </tr>
          <tr>
            {/* <td><Link to="/inventory/grnRejectionReport">GRN Rejection - Report</Link></td> */}
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default GRNMenu_report;
